/**
 * Platform detection for keyboard rendering.
 *
 * Decides whether to draw ⌘/⌥ glyphs (mac) or `Ctrl+`/`Alt+` words (other).
 * Prefers the modern `navigator.userAgentData.platform`, falling back to the
 * user-agent string. Affects display only — matching is platform-agnostic via
 * the `mod` modifier.
 */

import type { KbdPlatform } from './keybinding.types';

export function getPlatform(): KbdPlatform {
  const nav = navigator as Navigator & { userAgentData?: { platform?: string } };
  const source = nav.userAgentData?.platform ?? nav.userAgent ?? '';
  return /mac/i.test(source) ? 'mac' : 'other';
}
